import styled from 'styled-components';

const TR = styled.tr`
  padding: 0.75rem;
  border: 1px solid #D1D1D1;
  vertical-align: bottom;
  &:hover{
    background-color:${(props) => (props.noHover) ? 'transparent' : ' #e6e6e6'};
    color:${(props) => (props.noHover) ? 'unset' : 'black'};
  }
`;

export default TR;



// WEBPACK FOOTER //
// ./app/components/Table/TR.js